import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { SystemService } from 'src/app/services/system.service';
import { StatsService } from 'src/app/services/stats.service';
import { ReportService } from 'src/app/services/report.service';
import { CaseListFilterDto } from 'src/app/reports/dto/report-filters-dto';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'case-list',
  templateUrl: './case-list.component.html'
})
export class CaseListComponent implements OnInit {
    myFilter: CaseListFilterDto;  // filter object

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        summaryDiv: false,
        caseListDiv: false,
    };

    viewCount = 0;
    // dictionaries
    statusList = [];
    subStatusList = [];
    propTypeList = [];
    useCodeList = [];
    cityList = [];
    assessTypeList = [];
    secureList = [];
    hearingsList = [];
    specialCaseList = [];
    divisionList = [];
    crewList = [];
    appraiserList = [];
    sortByList = [];
    isAssessor = false;          // determine if user has Assessor-related user role
    userName = '';
    userRole = '';   // user role, i.e. Administrator, Assessor, Assessor-Manager, etc...
  //

    constructor(private dictService: DictionaryService,
                private utilService: UtilitiesService, private sysService: SystemService,
                private schedService: ScheduleService, private messageService: MessageService,
                private reportService: ReportService, private cookieService: CookieService,
                private statsService: StatsService) { }

    ngOnInit() {
      this.utilService.doAudit('onInit for Case-List component');
      let uRole = this.cookieService.get('userRole'); // get the role from login cookie
      if (uRole) {
        this.userRole = uRole;
      } else {
        uRole = this.userRole;
      }
      this.userName = this.cookieService.get('userName');
      if (uRole.includes('Assessor')) {
        this.isAssessor = true;
      }
      this.viewCount = 0;
        this.displayState.workingDiv = true;
        this.resetFilters();
        this.loadDictionaries();
        // this.searchAllApplications();
    }

    // determine if user has specified any filters; should we validate some of the values (i.e. dates)??
    needVariables() {
        return false;
    }

    resetFilters() {
        this.myFilter = {
            specialCase: '',
            division: '',
            closedOpen: '',
            appraiser: '',
            appraiserId: '',
            crew: '',
            fromDateRecvd: null,
            thruDateRecvd: null,
            fromDateClosed: null,
            thruDateClosed: null,
            currentStatus: '',
            refund: '',
            complexCase: '',
            subStatus: '',
            propType: '',
            propStreet: '',
            propCity: '',
            tra: '',
            assessType: '',
            applicant: '',
            agency: '',
            secured: '',
            hearingId: '',
            noticeReturned: '',
            waiver: '',
            useCode: '',
            sortBy: '',
            exportExcel: false,
            isAssessor: this.isAssessor,
        };
    }
    runCaseListReport() {
      this.utilService.doAudit(this.myFilter, 'myFilter:');
      const filterStr = this.genFilterStr(this.myFilter);
      if (filterStr.length < 1) {
        this.showToast({key: 'toast', severity: 'info', detail: 'Please specify a value for at least ONE Selection Variable', summary: 'Info' });
        return;
      }
      this.displayState.workingDiv = true;
      this.myFilter.isAssessor = this.isAssessor; // just in case...
      this.reportService.getCaseList(this.myFilter).subscribe(data => {
        this.utilService.doAudit('got response from getCaseList:');
        this.displayState.workingDiv = false;
        if (data) {
          // const myBlob = new Blob(myData, {type: 'application/pdf'} );
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        }
      });
    }
  private genFilterStr(filObj: any): string {
        const dtFields = ['fromDateRecvd', 'thruDateRecvd', 'fromDateClosed', 'thruDateClosed'];  // we'll need to convert Date values to acceptable format...
        let retStr = '';
        let propVal = '', dtIdx: number;
        for (let prop in filObj) {
            // console.log(prop);
            propVal = filObj[prop];
            if (propVal == null) { continue }
            if (propVal.length === 0) { continue }
            dtIdx = dtFields.indexOf(prop);
            if (dtIdx > -1) {
                propVal = this.utilService.formatDate(propVal);
            }
            retStr = (retStr ? retStr + '&' : '') + prop + '=' + encodeURIComponent(propVal);
        }
        return retStr;
    }

    // load all dictionaries used by Select elements
    loadDictionaries() {
        // hard code some dictionaries specific to this report; IFF they apply to other reports, consider moving them to the dictionary service
        this.sortByList = ['Case', 'Applicant', 'APN'];
        this.secureList = ['Secured', 'Unsecured'];
        // get some generally used dictionaries, i.e. cityList, statusList, etc...
        const dicts = this.dictService.getDictionaries();
        this.utilService.doAudit(dicts, 'dicts');
        this.cityList = dicts.cityChoices;
        this.statusList = dicts.statusChoices;
        this.subStatusList = dicts.subStatusChoices;
        this.propTypeList = dicts.propertyTypes;
        this.assessTypeList = dicts.assessTypes;
        //
        // now we get various dictionaries defined on the backend/DB
        this.dictService.getCaseDictionaries('crew').subscribe(data => {
            this.utilService.doAudit(data, 'crew dictionary:');
            if (data) {
                this.crewList = data;
            }
            this.viewCount = ++this.viewCount;
        });
        this.dictService.getCaseDictionaries('division').subscribe(data => {
            this.utilService.doAudit(data, 'division dictionary:');
            if (data) {
                this.divisionList = data;
            }
            this.viewCount = ++this.viewCount;

        });
        this.dictService.getCaseDictionaries('specialcase').subscribe(data => {
            if (data) {
                this.specialCaseList = data;
            }
            this.viewCount = ++this.viewCount;
        });
        this.dictService.getCaseDictionaries('usecode').subscribe(data => {
            this.utilService.doAudit(data, 'usecode dictionary:');
            if (data) {
                this.useCodeList = data;
            }
            this.viewCount = ++this.viewCount;
        });
        this.dictService.getAssessorList().subscribe(data => {
            if (data) {
                this.utilService.doAudit(data, 'Appraiser dictionary:');
                this.appraiserList = data;
                this.appraiserList.unshift( { id: 0, name: 'Not Assigned', isActive: false });

            }
            this.viewCount = ++this.viewCount;
        });
        this.getHearingDates();
        this.displayState.workingDiv = false; // hide the Progress message/spinner, even though we're still waiting for some of the dropdowns to be populated...
    }

    // get list of defined Hearing Dates
    getHearingDates() {
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        const baseDate = new Date();
        baseDate.setDate(baseDate.getDate() - 1); // subtract 1 day
        this.schedService.getHearingDates().subscribe(data => {
            this.utilService.doAudit(data, 'response from getHearingDates');
            if (data) {
              // only display future dates; as per Anthony Luis, include today - 3/27/2025
              const futureDates = data.filter(t => {
                const tHearDt = new Date(t.hearingDate);
                return tHearDt >= baseDate ? t : null;
              });
              // as per Anthony Luis (Assessor manager), sort hearing dates in Ascending order - 3/10/2025
              futureDates.sort((a, b) => {
                // @ts-ignore
                return new Date(a.hearingDate) - new Date(b.hearingDate);
              });
              const mapped = futureDates.map(item => ({
                ...item,
                hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
              }));

              this.hearingsList = mapped;
            }
            /*
            // *** NOTE:    during testing, you can switch to using the hearingDateList instead of the futureHearingDateList
            if (data) {
                this.hearingsList = data.filter(t=> {
                    let tHearDt = new Date(t.hearingDate)
                    return tHearDt > tdy? null: t
                });
                this.hearingsList = data.filter(t=> {
                    let tHearDt = new Date(t.hearingDate)
                    return tHearDt > tdy? t: null
                })
            }*/
        });
    }

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
        }

    clear() {
        this.messageService.clear();
    }
}
